
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Codman_classification_of_proximal_humeral_fractures",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Codman_classification_of_proximal_humeral_fractures.vue